import React from "react";
import type { AssistantMediaPart } from "../../../chat/types";
import { useChatServices } from "../providers/ChatProvider";
import { MediaImageCard } from "./MediaImageCard";
import { MediaAudioCard } from "./MediaAudioCard";
import { MediaVideoCard } from "./MediaVideoCard";

interface Props { part: AssistantMediaPart }

export function MediaCard({ part }: Props) {
  const { registry } = useChatServices();
  const custom = registry.getRenderer("media_card");
  if (custom) {
    return <>{custom(part as any)}</>;
  }
  switch (part.media_kind) {
    case "image": return <MediaImageCard part={part} />;
    case "audio": return <MediaAudioCard part={part} />;
    case "video": return <MediaVideoCard part={part} />;
  }
}
